<app-modal
  class="modal"
  [title]="'Upload Documents'"
  [displayModal]="true"
>
    <app-upload-file
      [noUploadDropzone]="false"
      [courseItemId]="courseItemId"
      [fileTypeInS3]="'COURSE_DOCUMENT'"
      [showReplaceButton]="false"
      [enableWebPConversion]="true"
      [webPQuality]="0.8"
      (uploadComplete)="uploadCompleted()"
    >
    </app-upload-file>


    <div class="footer" footer>
      <app-new-button
        (clickHandler)="closeModalHandler()"
        size="sm"
        color="bare"
        customPadding="12px 16px"
        >Cancel</app-new-button
      >
      <app-new-button
        (clickHandler)="uploadDocuments()"
        size="sm"
        color="green"
        leftIcon="check"
        customPadding="12px 16px"
        >Upload</app-new-button
      >
    </div>
</app-modal>